"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = require('./menuLink.scss');

var MenuLink = function MenuLink(_ref) {
  var depth = _ref.depth,
      section = _ref.section,
      partials = _ref.partials,
      _ref$theme = _ref.theme,
      _ref$theme$linkBgColo = _ref$theme.linkBgColor,
      linkBgColor = _ref$theme$linkBgColo === void 0 ? '#fff' : _ref$theme$linkBgColo,
      _ref$theme$linkColor = _ref$theme.linkColor,
      linkColor = _ref$theme$linkColor === void 0 ? 'red' : _ref$theme$linkColor;
  var MenuIcon = partials.MenuIcon;
  return _react["default"].createElement(_reactRouterDom.NavLink, {
    className: "".concat(styles['menu-link'], " depth-").concat(depth),
    activeStyle: {
      background: linkBgColor,
      color: linkColor
    },
    to: "".concat(section.path)
  }, _react["default"].createElement(MenuIcon, {
    section: section
  }), _react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: section.title
    }
  }));
};

MenuLink.propTypes = {};
MenuLink.defaultProps = {};
var _default = MenuLink;
exports["default"] = _default;